<template>
<div v-if="category">
	<ul class="title-nav">
		<li v-on:click="routeBack()">
			<div class="back-btn">
				<i class="material-icons md-18">keyboard_arrow_left</i>
			</div> 
			
			<div class="title-label text-uppercase"><i class="fas fa-pen-nib fa-fw"></i> {{category.name}}</div>
		</li>
	</ul>
	<ul class="services-list">
		<li v-if="services" v-for="(service, index) in services" v-on:click="routeService(service)">
			<h4 class="service-item-title">{{service.title}}</h4>
			<p class="service-item-body">{{service.body}}</p>
			<div class="clearfix">
				<a v-bind:href="getPhoneHref(service.phone)" v-if="service.phone" class="btn btn-dark float-right ml-2"><i class="far fa-phone-alt fa-fw"></i> {{service.phone}}</a>
				<span class="btn btn-dark float-right ml-2" v-on:click="handleMessageClick"><i class="far fa-envelope fa-fw"></i> Message</span>
			</div>
		</li>
	</ul>
	<div class="" v-if="showForm || services && services.length < 1">
		<div class="mb-4 mt-4 ">
			<h3 class="mb-2 text-center">
				SERVICE INQUIRY
			</h3>
			<p>
				Fill in the following details about your project. We'll have one of our service professionals reach out to you as soon as possible.
			</p>
		</div>
		<form class="" v-on:submit.prevent="submit">
			<div class="form-group">
				<label class="mb-1" for="signUpEmail">Describe your project and what you'd like done</label>
				<textarea class="form-control" id="signUpEmail" aria-describedby="emailHelp" 
					placeholder="Project description" v-model="description"
					v-bind:class="{'is-invalid':error && error.description}"/>
				<div class="invalid-feedback">
					{{error && error.description}}
		    </div>
			</div>
			<div class="form-group">
				<label class="mb-1" for="loginEmail">Email</label>
				<input type="email" class="form-control" id="loginEmail" aria-describedby="emailHelp" 
					placeholder="Enter email" v-model="email"
					v-bind:class="{'is-invalid':error && error.email}"/>
				<div class="invalid-feedback">
					{{error && error.email}}
		    </div>
			</div>
			<div class="form-group">
				<label class="mb-1" for="loginEmail">Phone</label>
				<input type="phone" class="form-control" id="loginEmail" aria-describedby="phoneHelp" 
					placeholder="Enter phone" v-model="phone"
					v-bind:class="{'is-invalid':error && error.phone}"/>
				<div class="invalid-feedback">
					{{error && error.phone}}
		    </div>
			</div>
			<div class="text-right">
				<button class="btn btn-dark">Submit</button>
			</div>
		</form>
	</div>
	<div class="" v-if="showSubmitted">
		<div class="mb-4 mt-4 ">
			<h3 class="mb-2 text-center">
				INQUIRY SUBMITTED
			</h3>
			<p>
				We're reaching out to our network and will contact you soon regarding this request.
			</p>
			<div class="text-right">
				<button v-on:click="handleDone" class="btn btn-dark">Done</button>
			</div>
		</div>
	</div>
	

</div>
</template>

<style>

.button-label{line-height:31px;}
.font-sm{font-size:0.8em;}
</style>

<script>

export default {
	name:'parcel-service-inquiry',
	created: function(){
		// get category data if it does not exist

		this.clearServices();

		if (!this.categories){
			this.getCategories();
		}

		this.getServices();

		if (this.agentRec){
			this.$data.email = this.agentRec.email
		}

	},
	data:()=>{
		return {
			description:null,
			email:null,
			error:null,
			phone:null,
			showForm:false,
			showSubmitted:false,
		}
	},
	props: {
		categoryId:{
			type:String,
		},
		parcel:{
			type:Object
		},
		addressId:{}
	},
	computed: {
		agentRec: function(){
			return this.$store.state.agent.rec;
		},
		category: function(){
			return this.$store.getters.serviceCategoryById(this.categoryId)
		},
		categories: function() {
			//console.log('parcel computed:',this.$store.state.parcel.rec);
			return this.$store.state.service.categories;
		},
		services: function() {
			//console.log('parcel computed:',this.$store.state.parcel.rec);
			return this.$store.state.service.services;
		},
	},
	methods:{
		clearServices: function(){
			this.$store.dispatch('SERVICES_CLEAR', {categoryId: this.categoryId}).catch((error)=>{
			});		
		},
		getCategories: function(){
			this.loadError = null;
			this.$store.dispatch('SERVICE_CATEGORIES_GET', {}).catch((error)=>{
				this.loadError = error;
			});			
		},
		getPhoneHref: function(phone){
			return `tel:${phone}`
		},
		getServices: function(){
			this.loadError = null;
			this.$store.dispatch('SERVICES_GET', {categoryId: this.categoryId}).catch((error)=>{
				this.loadError = error;
			});			
		},
		handleDone: function(){
			this.$data.showSubmitted = false
		},
		handleMessageClick:function(){
			this.$data.showSubmitted = false
			this.$data.showForm = true;
		},
		routeService:function(category){
			this.$router.push({
				name:'parcel-service',
				params:{
					id:this.parcel.id,
					category
				},
				query:{
					addressId:this.addressId
				}
			});
		},
		routeBack:function(){
			this.$router.push({
				name:'parcels-tab',
				params:{
					id:this.parcel.id,
					tab:'services'
				},
				query:{
					addressId:this.addressId
				}
			});
		},
		submit: async function(){
			const inquiry = {
				category:{
					id:this.categoryId
				},
				description:this.$data.description,
				email:this.$data.email,
				phone:this.$data.phone,
				parcel:{
					id:this.parcel.id
				},
			}

			await this.$store.dispatch('SERVICE_INQUIRY_SEND', {inquiry}).catch((error)=>{
				this.loadError = error;
			});			

			if (!this.loadError){
				this.$data.showForm = false
				this.$data.showSubmitted = true
				// clear out input fields
				this.$data.description = null
			}
		}
	}
}

</script>




// WEBPACK FOOTER //
// src/components/parcel/parcel-service-inquiry.vue